import React from "react"
import Layout from "../components/layout"
import Absractform from "../components/SubmitAbstract"
const SubmitAbstract = () => {
  return (
    <Layout>
      <Absractform></Absractform>
    </Layout>
  )
}

export default SubmitAbstract
